/* eslint-disable max-len */
import React from 'react';

const ConvertToLinkIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.26 5.96L4.15 4.844a.496.496 0 0 1 .699-.7l1.135 1.14C7.04 4.427 8.211 4 9.5 4c2.667 0 4.833 1.833 6.5 5.5-.672 1.478-1.425 2.658-2.26 3.54l1.114 1.117a.496.496 0 0 1-.7.7l-1.138-1.141C11.96 14.572 10.789 15 9.5 15 6.833 15 4.667 13.167 3 9.5c.672-1.478 1.425-2.658 2.26-3.54zm2.857 1.457a2.5 2.5 0 0 1 3.466 3.466l1.452 1.452c.667-.71 1.287-1.651 1.86-2.835C13.412 6.44 11.621 5 9.5 5c-1.008 0-1.942.326-2.804.996l1.421 1.421zM4.105 9.5C5.588 12.56 7.379 14 9.5 14c1.008 0 1.942-.326 2.804-.996l-1.421-1.421a2.5 2.5 0 0 1-3.466-3.466L5.965 6.665c-.667.71-1.287 1.651-1.86 2.835zm4.043-.652a1.5 1.5 0 0 0 2.003 2.003L8.149 8.849zM11 9.5a1.5 1.5 0 0 0-2.152-1.352l2.004 2.004c.095-.198.148-.419.148-.652z"
    />
  </svg>
);

export default ConvertToLinkIcon;
